module.exports = __webpack_public_path__ + "static/media/react.33c9b0e4.jpg";